/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Precheck_NoInputs */

const en_dialogue_list_export_precheck_no = /** @type {(inputs: Dialogue_List_Export_Precheck_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_dialogue_list_export_precheck_no = /** @type {(inputs: Dialogue_List_Export_Precheck_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_dialogue_list_export_precheck_no = /** @type {(inputs: Dialogue_List_Export_Precheck_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEIN`)
};

const it_dialogue_list_export_precheck_no = /** @type {(inputs: Dialogue_List_Export_Precheck_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NO`)
};

const ru_dialogue_list_export_precheck_no = /** @type {(inputs: Dialogue_List_Export_Precheck_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const es_dialogue_list_export_precheck_no = /** @type {(inputs: Dialogue_List_Export_Precheck_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_cn2_dialogue_list_export_precheck_no = /** @type {(inputs: Dialogue_List_Export_Precheck_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不`)
};

const ja_dialogue_list_export_precheck_no = /** @type {(inputs: Dialogue_List_Export_Precheck_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const hi_dialogue_list_export_precheck_no = /** @type {(inputs: Dialogue_List_Export_Precheck_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const pt_pt2_dialogue_list_export_precheck_no = /** @type {(inputs: Dialogue_List_Export_Precheck_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Dialogue_List_Export_Precheck_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_precheck_no = /** @type {((inputs?: Dialogue_List_Export_Precheck_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Precheck_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_precheck_no(inputs)
	if (locale === "de") return de_dialogue_list_export_precheck_no(inputs)
	if (locale === "it") return it_dialogue_list_export_precheck_no(inputs)
	if (locale === "ru") return ru_dialogue_list_export_precheck_no(inputs)
	if (locale === "es") return es_dialogue_list_export_precheck_no(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_precheck_no(inputs)
	if (locale === "ja") return ja_dialogue_list_export_precheck_no(inputs)
	if (locale === "hi") return hi_dialogue_list_export_precheck_no(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_precheck_no(inputs)
	return en_dialogue_list_export_precheck_no(inputs)
});